export enum SearchSubjectKind {
  BRAND = "brand",
  LEGAL_ENTITY = "legal_entity",
}

export const dataBySearchSubjectKind: Record<
  SearchSubjectKind,
  { label: string }
> = {
  [SearchSubjectKind.BRAND]: { label: "Brand" },
  [SearchSubjectKind.LEGAL_ENTITY]: { label: "Legal entity" },
}
